import { Api, signalr } from '@/service';
import RuleSelector from '../Rule.Selector.i18n'
import RuleQuickSetup from '../Rule.Quick.Setup.i18n'
import RuleService from '../Rule.Service.i18n'
import RuleIP from '../Rule.IP.i18n'
import RuleMethod from '../Rule.Method.i18n'
import RuleCustom from '../Rule.Custom.i18n'
import RuleCountry from '../Rule.Country.i18n'
import LogDetail from '../../log/Log.Detail.i18n'
import _ from 'lodash'
// import AgentList from '../Modules.List';
import punycode from 'punycode'
import codes from '@/codes'
import { VclFacebook } from 'vue-content-loading';
import moment from 'moment-timezone'
import CountryFlag from 'vue-country-flag'
import Bell from 'vue-notification-bell'
import ruleI18n from '../../log/rule.i18n' // 정책 번영 파일 추가
import reg from '@/reg'
import { Switch as cSwitch } from '@coreui/vue'
import agent from '../service'
import VueSpeedometer from "vue-speedometer"
import FolderSet from '../FolderSet.i18n';


const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: 'Message', sortable: false },
    { key: 'ruleid', label: 'RuleID', sortable: false },
    { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 15%' },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '일시', sortable: false, thStyle: 'width: 14%' },
    { key: 'remote_addr', label: '공격자', sortable: false, thStyle: 'width: 10%' },
    { key: 'severity', label: '위험도', sortable: false, thStyle: 'width: 10%' },
    { key: 'message', label: '설명', sortable: false },
    { key: 'ruleid', label: '정책 ID', sortable: false },
    { key: 'is_block', label: '대응', sortable: false, thStyle: 'width: 15%' },
  ]
};
const default_setting = () => ({ mode: 0, level: 1, limit_cpu : 90, limit_ram : 90, limit_disk : 90, resolve_cpu : 0, resolve_ram : 0, resolve_disk : 0, });
const default_user = () => ({
  block : [],
  detect : [],
  parameter: '',
  path: '',
  allow_ip : '',
  block_ip : '',
  country_code : [],
  custom_rule : '',
  use_geoip : false,
  use_method : false,
  method_control : [],
});
export default {
  props: ['is_one', 'agent_list'],
  components: { RuleCountry, RuleSelector, RuleQuickSetup, RuleService, RuleIP, RuleCustom, VclFacebook, CountryFlag, Bell, cSwitch, VueSpeedometer, FolderSet, LogDetail, RuleMethod },
  data: () => {
    return {
      ping_th : undefined,
      info : {},
      // auth,
      modal_log : false,
      modal_log_id : 0,
      modal_name : false,
      nickname_modify_modal : false,
      modify_nickname : '',
      ruleI18n,
      using_redir : '',
      explain_mode : false,
      codes,
      // 빠른 설정 관련
      ico : { width: 30, height: 30, class: 'm1' },
      quick_modal : false,
      quick_setting_status : false,
      is_first : false,
      quick_setting : {
        DRUPAL : { use : true, key : [], indeterminate : false },
        WORDPRESS : { use : true, key : [], indeterminate : false },
        JAVA : { use : true, key : [], indeterminate : false },
        IIS : { use : true, key : [], indeterminate : false },
        PHP : { use : true, key : [], indeterminate : false }
      },
      policy_list : [],
      apply_all_server: [],
      apply_confirm_modal : false,
      apply_modal : false,

      sel_domain : { index : 0, domain : "default", rule : [], mode : 0, level : 1, status : true, temp : false },
      policy_default : {
        block : [],
        detect : [],
        rule : [],
        mode : 0,
        level : 1,
        parameter: [],
        url: [],
        allow_ip : [],
        block_ip : [],
        custom_rule : '',
      },
      changed_status : false,
      // 아래 변수 사용 여부 확인 필요
      is_redir : false,

      explain_user_domain : false,
      domain_remove : undefined,
      policy_select : false,
      checked_policy : [],
      target_select : false,
      select_default : false,
      checkedNames : [],
      explain_level : false,
      detect : [],
      block : [],
      rule_confirm : false,
      status_confirm : false,
      explain_user_crs : false,

      // start websocket val
      signalr,
      sel_rule : {},
      domain : '',
      Rule : '',
      setting : {
        mode : 0,
        level : 1,
        limit_mode : false,
        limit_cpu : 90, limit_ram : 90, limit_disk : 90,
        resolve_cpu : 60, resolve_ram : 60, resolve_disk : 60,
      },
      // end websocket val
      // confirm : false, // for explain modal
      perPage: 50, // for log showing count
      currentPage: 1,
      totalRows: 50,
      tabIndex: 0,
      default_rule : {},
      user: {}, // 사용자 설정
      rule_set : {},
      server : { url : "", policy_json : { domains : [] } },
      // end default
      policy: {},
      target_list: [],
      loading: true,
      domain_manage_fields : [
        { key : 'domain', label: 'Domain' },
        { key : 'status', label: 'Status' },
        { key : 'mode', label: 'Mode' },
        { key : 'level', label: 'Policy Security Level' },
        { key: 'button', label: 'Action' },
      ],
      // fields : [
      //   { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 5%' },
      //   { key: 'created_at', label: 'DateTime', sortable: false, thStyle: 'width: 15%' },
      //   { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 5%' },
      //   { key: 'severity', label: 'Risk', sortable: false, thStyle: 'width: 10%' },
      //   { key: 'message', label: 'Message', sortable: false },
      //   { key: 'ruleid', label: 'RuleID', sortable: false },
      //   { key: 'is_block', label: 'Response', sortable: false, thStyle: 'width: 15%' },
      // ],
      th : undefined,
      crs_rule : { id : 0, version : '', agent_version : '-' }, // 현재 사용중인 변경될 CRS 정책 메타 데이터
      crs_version_list : [],
      change_main_policy : false,
      target_crs_rule : { id : 0, version : '', agent_version : '-' }, // 변경될 CRS 정책 메타 데이터
    }
  },
  computed: {
    ramStatus() { return this.info.status && this.info.status.system_memory_info ? Number(this.info.status.system_memory_info.usedPercent.toFixed(0)) : 0 },
    cpuStatus() { return this.info.status && this.info.status.system_cpu_info ? this.info.status.system_cpu_info.usage * 10 : 0 },
    disckStatus() { return this.info.status && this.info.status.system_disk_info ? _.filter(this.info.status.system_disk_info.info, x => x.mountpoint && x.percent) : [] },
    runStatus() { return this.info && this.info.status && this.model.status.running == true },
    crs_rule_count() {
      return _.filter((this.crs_version_list || []), x => x.id > this.crs_rule.id).length
    },
    fields() { return i18n_fields[this.i18n]; },
    startRow () { return this.totalRows - (this.currentPage - 1) * this.perPage; },
  },
  methods: {
    line_count: function() { return this.user.custom_rule.length ? this.user.custom_rule.split(/\r\n|\r|\n/).length + 3 : 3; },
    base64encode(x) { return window.btoa(encodeURIComponent(x)) },
    base64decode(x) { return decodeURIComponent(window.atob(x)) },
    change_policy_name(x) {
      console.log('apply to ', x)
      this.sel_domain = Object.assign(this.sel_domain, { domain : x })
    },
    log_view(item) {
      this.modal_log = true
      this.modal_log_id = item.id
    },
    // default function
    async nickname_modify() {
      try{
        if(!this.modify_nickname) { return this.$toastr.w("require new nickanme") }

        let rs = await Api.Manager('webcastle.agent', 'update', Object.assign({}, this.server, { nickname : this.modify_nickname }));

        this.nickname_modify_modal = false
        if(rs.error) { return this.$toastr.e("update failed") }
        this.server.nickname = this.modify_nickname
        this.modify_nickname = '';
        this.$toastr.i("Success.")
      } catch(e) { console.log(e) }
    },
    get_max_policy() {
      try {
        let latest =  _.maxBy(this.crs_version_list, x => x.id)
        return latest && this.crs_rule && this.crs_rule.version != latest.version ? latest.version : ''
      } catch (e) { console.log(e); this.$toastr.e("load error #5"); return '' }
    },
    redir_change(x) { this.is_redir = x && x.length ? true : false },
    list() {
      this.$parent.$emit('refresh')
      this.$router.push({ name: 'webcastle_modules'});
    },
    // 퀵 설정 저장 함수
    save_default(policy) {
      try {
        this.sel_domain =  Object.assign({}, this.sel_domain, policy)
        this.setting.level = policy.level
        this.user = Object.assign({}, this.user,  { block_ip : policy.block_ip, allow_ip : policy.allow_ip, path : policy.path })
        this.setting.mode = policy.mode

        // console.log(policy.rule, 'policy.rule')
        // 룰 저장 함수
        this.policy_rule(policy.rule)

        // 빠른 설정 끝
        this.quick_setting_status = false
        this.server.updated_at = moment().format('YYYY MM DD HH:mm:ss')

      } catch (e) { console.error(e) }
    },
    domain_direct_remove(item) {
      try {
        this.domain_remove = item.domain
        // 임시 도메인이면 바로 지금
        if(item.temp) { return this.domain_manage_remove(item.domain) }
        // 그게 아니면 지우는 모달 토글
        this.explain_user_domain = true
      } catch (e) { console.error(e) }
    },
    // 다른 서버 적용 함수 시작
    async multi_save() { // 설정 저장
      try{
        let policy_list = _.map(this.policy_list, r => _.find(this.server.policy_json.domains, { "domain" : r }))
        let body = { policy_list : policy_list, server_list : this.apply_all_server.map(r => r.id) }
        this.apply_all_server = []
        let rs = await Api.Manager('webcastle.agent', 'update.policy', body);
        if(rs.error) { return this.$toastr.e("update failed") }
        this.$toastr.s('Apply to agents.');
        this.$emit('refresh');
        this.apply_confirm_modal = false
        this.apply_modal = false
      } catch(e) { this.catch_msg(e) }
    },
    multi_remove(index) { this.apply_all_server.length < 2 ? this.apply_all_server = [] : this.apply_all_server.splice(index, 1) },
    multi_one(item) {
      if(item) {
        if(!item) { return 'no have a data' }
        // console.log(item, this.apply_all_server)
        if(item.is_del) {
          this.apply_all_server = this.apply_all_server.map(r => { if (r && r.id != item.id) { return r } }).filter( r => r != null)
        } else {
          this.apply_all_server.push(item)
        }
      }
     },
    multi_all(items) { (items || []).map(r => { r && _.filter(this.apply_all_server, { nickname : r.nickname }).length < 1 ? this.apply_all_server.push(r) : '' }) },
    multi_clear() { this.apply_all_server = [], console.log("clear") },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
    // 다른 서버 적용 함수 끝
    toggle_policy($value, key, type=undefined) {
      // 특정 룰을 사용하지 않음
      // console.debug("is index", key)
      let rindex = _.findIndex(this.rule_set.rule, x => x.key == key);
      rindex > -1 ? this.$refs.RuleSelector.$children.forEach(r => r.policy_toggle(rindex, -1, $value)) : ''


    },
    filterBlank(x) { return x ? _.uniq(_.map( typeof x == 'string' ? x.split('\n') : x, r => r.trim())) : [] },
    async policy_rule(rule) {
      try {
        // 레벨 alc
        // this.server.level = this.setting.level
        // this.server.mode = this.setting.mode

        // 임시 룰 삭제, 저장하지 않음
        for(var i = 0; i < this.server.policy_json.domains.length; i++){
          if(this.server.policy_json.domains[i].temp){
            delete this.server.policy_json.domains[i].temp;
          }
        }
        console.log("update or remove", this.sel_domain.domain)
        let index = _.findIndex(this.server.policy_json.domains, {domain : this.sel_domain.domain})
        let domain = this.server.policy_json.domains[index];

        // console.log(this.setting, "setting", domain, index, this.server.policy_json.domains)
        domain.mode = this.setting.mode;
        domain.level = this.setting.level;
        domain.rule = _.uniq(rule);

        // 가장 최근에 저장한 설정이 보여지도록
        this.server.level = domain.level
        this.server.mode = domain.mode


        // 다시 룰 넣기
        this.server.policy_json.domains[index] = Object.assign({}, this.server.policy_json.domains[index], { rule : domain.rule })

        // console.debug('test', domain.mode, codes.WAF_MODE_OFF.VALUE)
        this.user.custom_rule = this.user.custom_rule;
        domain.custom_rule = this.user.custom_rule ? this.base64encode(this.user.custom_rule) : '';
        domain.redirection = this.using_redir
        // if(this.using_redir) { domain.custom_rule += `\nSecRuleUpdateActionById 901000-90000000 "t:none,log,auditlog,msg:'Custom redirection',deny,redirect:'${this.using_redir}'"` }

        this.user.block_ip = this.filterBlank(this.user.block_ip)
        domain.block_ip = this.user.block_ip && this.user.block_ip.length ? this.user.block_ip : [];
        this.user.block_ip = (this.user.block_ip || []).join('\n')

        this.user.allow_ip = this.filterBlank(this.user.allow_ip)
        domain.allow_ip = this.user.allow_ip && this.user.allow_ip.length ? this.user.allow_ip : [];
        this.user.allow_ip = (this.user.allow_ip || []).join('\n')

        this.user.path = this.filterBlank(this.user.path)
        domain.path = this.user.path && this.user.path.length ? this.user.path : [];
        this.user.path = (this.user.path || []).join('\n')

        this.user.parameter = this.filterBlank(this.user.parameter);
        domain.parameter = this.user.parameter && this.user.parameter.length ? this.user.parameter : [];
        this.user.parameter = (this.user.parameter || []).join('\n')

        // this.$refs._country.
        this.user.country_code = this.filterBlank(this.user.country_code);
        domain.country_code = this.user.country_code && this.user.country_code.length ? this.user.country_code : [];
        // this.user.country_code = (this.user.country_code || []).join('\n')

        domain.use_geoip = this.user.use_geoip

        // 미사용중인 룰 필터링
        // console.log(domain.mode, 'domain.mode', domain.mode == codes.WAF_MODE_ON.VALUE)
        if(domain.mode == codes.WAF_MODE_ON.VALUE) {
          domain.block = this.sel_domain.block && this.sel_domain.block.length ? _.filter(this.sel_domain.block, r => _.indexOf(domain.rule, r) < 0) : [];
          this.sel_domain.block = domain.block
          domain.detect = this.sel_domain.detect && this.sel_domain.detect.length ?  _.filter(this.sel_domain.detect, r => _.indexOf(domain.rule, r) < 0) : [];
          this.sel_domain.detect = domain.detect
        } else {
          // off or detectionOnly
          domain.detect = domain.block = []
        }

        let mode = domain.mode = domain.mode == codes.WAF_MODE_ON.VALUE ? codes.WAF_MODE_ON.TEXT : (domain.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ? codes.WAF_MODE_DETECTIONONLY.TEXT : codes.WAF_MODE_OFF.TEXT)
        this.server.policy_json.domains[index] = Object.assign({}, domain, { mode : mode })
        if(!this.changed_status && domain.mode != codes.WAF_MODE_OFF.VALUE) {
          // OFF 가 아니라면 사용하기 위해 On
          this.server.policy_json.status = true
          this.setting.status = this.server.policy_json.status
        }

        this.server.setting = JSON.stringify(
          {
            limit_cpu : this.setting.limit_cpu,
            limit_ram : this.setting.limit_ram,
            limit_disk : this.setting.limit_disk,
            resolve_cpu : this.setting.resolve_cpu,
            resolve_ram : this.setting.resolve_ram,
            resolve_disk : this.setting.resolve_disk,
            limit_mode : this.setting.limit_mode,
          }
        )

        // console.log(this.server.policy_json, 'final')

        this.server.policy = JSON.stringify(this.server.policy_json);
        delete this.server.token; // 토큰 삭제
        let rs = await Api.Manager('webcastle.agent', 'update', this.server);
        if(rs.error) { return this.$toastr.e("update failed") }

        this.$toastr.s("Saved successfully");
        this.changed_status = false

        this.get(false)

        this.$parent.$emit('refresh')
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
    async status_save(a){
      try{
        this.server.policy_json.status = a;
        this.server.policy = JSON.stringify(this.server.policy_json);
        let status_data = this.server;
        delete status_data.policy_json.id
        delete status_data.policy_json.body

        let rs = await Api.Manager({ target:'webcastle.agent', cmd:'update', body: status_data})
        if(rs.error) { return this.$toastr.e("update failed") }
        this.$toastr.s("Saved successfully")
        this.changed_status = true
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
    async save() {
      // 위의 함수에서 Update 날림.
      try {
        this.$refs.RuleSelector.$children.forEach(r => r.toss_rule())
        // this.$refs.RuleSelector.toss_rule();
        this.server.token = '';

        this.server.mode = this.setting.mode
        let update_data = this.server;
        delete update_data.policy_json.id
        delete update_data.policy_json.body

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'Save failed'); }
    },
    async domain_manage_remove(domain = undefined) {
      // Domain remove
      try{
        if(domain) { this.domain_remove = domain }

        let is_save = _.filter(this.server.policy_json.domains, r => r.domain == this.domain_remove && !r.temp).length > 0

        this.server.policy_json.domains = _.filter(this.server.policy_json.domains, r => r.domain != this.domain_remove)

        this.$refs._list ? this.$refs._list.refresh() : ''

        // 최근 추가된 도메인으로 설정함
        // this.sel_domain = Object.assign({}, this.sel_domain, this.policy_default, this.server.policy_json.domains[this.server.policy_json.domains.length - 1])
        this.sel_domain = Object.assign({}, this.sel_domain, this.policy_default)

        // console.log(_.filter(this.server.policy_json.domains, r => r.domain == this.domain_remove && !r.temp))
        // 이전 저장된 도매안 삭제시, 미저장 도메인은 바로 삭제
        if(is_save) {
          // 삭제된 도메인 필터
          console.log("remove & save")
          this.save();
        }


        console.log("sel domain is ", this.sel_domain.domain)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 8'); }
    },
    async domain_manage_regist(origin_domain=undefined, domain = undefined) {
      // Domain Add
      try {
        if(domain) { this.domain = domain }
        if(!this.domain) { return this.$toastr.w("Typing plz domain on server", "required!") }

        if(this.domain.indexOf(':') > -1 || this.domain.indexOf('\\/\\/') > -1) {
          return this.$toastr.w("Typing plz only domain, not include protocol")
        }

        const rs = await Api.Manager({target : 'webcastle.agent', cmd : 'domain.limit', body : new Date().getTime()})
        if(rs.error) { return this.$toastr.e("can't verify license") }
        // 라이선스 확인
        if(rs.body < this.server.policy_json.domains.length) { return this.$toastr.e("Number of domains exceeded! Please upgrade your license!")}
        // 중복 확인
        if(_.filter(this.server.policy_json.domains, d => d.domain == this.domain).length > 0) { return this.$toastr.e("duplicate!!"); }
        // 한글 도메인 등록
        if(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(this.domain)){ this.domain = punycode.toASCII(this.domain) }

        // clone 때문에 그럼
        // console.log(this.policy_default, default_user())
        let new_domain = origin_domain != undefined ?
          Object.assign({}, this.policy_default, this.sel_domain, this.user, { domain : this.domain }, { temp : true }) :
            Object.assign({}, this.policy_default, default_user(), { domain : this.domain }, { temp : true })

        // 모드 강제 설졍
        if(origin_domain != undefined) {
          new_domain.mode = this.setting.mode == codes.WAF_MODE_ON.VALUE ?
          codes.WAF_MODE_ON.TEXT :
            (this.setting.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ?
              codes.WAF_MODE_DETECTIONONLY.TEXT :
                codes.WAF_MODE_OFF.TEXT)
        } else {
          new_domain.mode = origin_domain === undefined && this.policy_default.mode == codes.WAF_MODE_ON.VALUE ?
          codes.WAF_MODE_ON.TEXT :
            (this.policy_default.mode == codes.WAF_MODE_DETECTIONONLY.VALUE ?
              codes.WAF_MODE_DETECTIONONLY.TEXT :
                codes.WAF_MODE_OFF.TEXT)
        }

        // 방화벽 룰
        this.server.policy_json.domains.push(Object.assign({}, new_domain));
        this.domain = ''
        // 설정 초기화
        this.setting = origin_domain != undefined ?
          Object.assign({}, this.setting, { status : this.setting.status }) :
            Object.assign({}, default_setting(), { status : this.setting.status })
        // 새로운 도메인 적용
        this.change_domain(new_domain.domain)
        // 새로고침
        this.$refs._list ? this.$refs._list.refresh() : ''
        // 여기까지 도메인 임시 저장
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 8'); }
    },
    getItems(ctx) { return this.load(ctx); },
    async load() {
      // Log List
      let so = {
        target : 'webcastle.log',
        cmd : 'list',
        offset : 0,
        limit :  50,
        body : {
          and : [ { name : "agent_id", value : Number(this.server.id), op : "=" } ],
          sort : [ { name : "id", op : "desc" } ]
        }
      }
      return await Api.Manager(so).then(rs => {
        this.totalRows = rs.total;
        return _.map(rs.body, r => {
          try { r.message = JSON.parse(r.message) } catch (e) { console.log("json parser failed"); r.failed = true; }

            // 메세지 앞에 탐지한 구문이 있을 경우, 탐지만으로 설정, 패턴 N 개 매칭으로 인한 코드 추가
            r.detect_cnt = _.filter(r.message.messages, x => _.startsWith(x.message.toLowerCase(), '[detectiononly]')).length
            r.block_cnt = r.message.messages.length - r.detect_cnt
            r.message = _.minBy(r.message.messages, function(x) { return Number(x.details.severity) })

            _.forEach(r.headers ? r.headers.split('\n') : [], line => {
              let ip = line.replace(/(x-forwarded-for:| )/ig, '')
              _.startsWith(line.toLowerCase(), 'x-forwarded-for') && reg.ip4.test(ip) ? (r.remote_addr = ip) : ''
            })

          return r
        })
      }).catch(e => {
        console.error(e)
        this.$toastr.e(e.data ? e.data.message : e.statusText)
      });
    },
    sync_log() {
      clearTimeout(this.th);
      if(this.tabIndex == 5) { this.$refs._list.refresh(); console.log('refresh real time') }
      this.th = setTimeout(() => { this.sync_log(); }, 5000 );
    },
    refresh() { if(!this.th) { this.sync_log(), console.log("start sync_log") } this.$refs && this.$refs._list ? this.$refs._list.refresh() : ''; },
    async change_target(s) {
      let rs = await Api.Manager({target : 'webcastle.agent', cmd : 'detail', body : { id : s }})
      if(rs.error) { return this.$toastr.e("agent load failed") }
      this.$router.push({ name: 'webcastle_modules', params: { id: rs.body.id }})
      this.$toastr.i("changed webcastle")
    },
    change_domain(domain){
      try {
        console.log("new Policy", domain.version)
        if(!domain) { return this.$toastr.e("no have seleted domain") }
        this.sel_domain = Object.assign({}, _.find(this.server.policy_json.domains, { domain : domain }));
        this.sel_domain.mode = this.sel_domain.mode == codes.WAF_MODE_ON.TEXT ? 2 : (this.sel_domain.mode == codes.WAF_MODE_DETECTIONONLY.TEXT ? 1 : 0)
        this.setting.mode = this.sel_domain.mode
        this.setting.level = this.sel_domain.level

        console.log("ss", this.sel_domain)

        this.user.use_geoip = this.sel_domain.use_geoip;
        this.user.country_code = this.sel_domain.country_code;
        this.user.block_ip = typeof this.sel_domain.block_ip == typeof '' ? this.sel_domain.block_ip : (this.sel_domain.block_ip || []).join('\n');
        this.user.allow_ip = typeof this.sel_domain.allow_ip == typeof '' ? this.sel_domain.allow_ip : (this.sel_domain.allow_ip || []).join('\n');
        this.user.path = typeof this.sel_domain.path == typeof '' ? this.sel_domain.path : (this.sel_domain.path || []).join('\n');
        this.user.parameter = typeof this.sel_domain.parameter == typeof '' ? this.sel_domain.parameter : (this.sel_domain.parameter || []).join('\n');
        this.user.custom_rule = this.base64decode(this.sel_domain.custom_rule);
        this.user.method_control = this.user.method_control ? this.user.method_control : []
        this.user.use_method = this.sel_domain.use_method;
        this.user.method_control.forEach(x => x.ip_list = typeof '' ==  x.ip_list ? x.ip_list : x.ip_list.join('\n'))


        this.using_redir = this.sel_domain.redirection
        this.is_redir = this.using_redir && this.using_redir.length > 0 ? true : false

        this.filter_rule()

        this.$refs.RuleSelector.$children.forEach(x => x.parser_setting())
      } catch (e) { console.log(e); this.$toastr.e("load error #1") }
    },
    async change_crs(){ // 정책 업데이트
      try {
        this.server.crs_id = this.target_crs_rule.id

        // 해당 에이전트 버전이 최소 버전보다 작을 경우 업데이트 불가 안내
        if(this.crs_rule.agent_version && this.target_crs_rule.agent_version && Number(this.crs_rule.agent_version.replace('.','')) < Number(this.target_crs_rule.agent_version.replace('.',''))) {
          return this.$toastr.e("Update Agent!, minimum version "+this.target_crs_rule.agent_version);
        }

        let rs = await Api.Manager({ target : 'webcastle.agent', cmd : 'update', body: this.server });
        if(rs.error) { return this.$toastr.e("update failed") }

        this.$toastr.s("Saved! , reload 3 sec later");

        this.loading = true
        this.change_main_policy = false

        setTimeout(() => location.reload(), 2000)

      } catch (e) { console.log(e); this.$toastr.e("load error #1") }
    },
    async get_policy_version() {
      // 기본 정책 로딩
      try {
        let rs_crs = await Api.Manager({ target : 'webcastle.policy', cmd : 'version', body : { id : this.server.crs_id } });
        if(rs_crs.error) { return this.$toastr.e("load failed policy") }
        this.crs_version_list = rs_crs.body
      } catch (e) { console.log(e); this.$toastr.e("load error #0") }
    },

    // initialize
    async get(reload=false){
      try {
        let id = this.$route.params.id

        // 에이전트 로딩
        if(reload == false) {

          console.log(id, 'id')

          let rs = await Api.Manager({ target : 'webcastle.agent', cmd: 'detail', body: { id : id }})
          if(rs.error) { return this.$toastr.e("load failed agent") }
          this.server = Object.assign({}, rs.body, { policy_json : JSON.parse(rs.body.policy) });
          this.setting = Object.assign({}, this.setting, this.server.setting ? JSON.parse(this.server.setting) : {})

          // 기본 정책 로딩
          let rs_crs = await Api.Manager({ target : 'webcastle.policy', cmd : 'detail', body : { id : this.server.crs_id } });
          if(rs_crs.error) { return this.$toastr.e("load failed policy") }
          this.default_rule = JSON.parse(rs_crs.body.crs_json);
          this.rule_set = JSON.parse(rs_crs.body.crs_json)
          this.crs_rule = Object.assign({}, this.crs_rule, { id : rs_crs.body.id })
          let select_policy = this.crs_version_list[_.findIndex(this.crs_version_list, x => x.id == this.crs_rule.id)]
          if(select_policy) { this.crs_rule = this.target_crs_rule = select_policy }

          this.get_policy_version()
        }


        // 에이전트 정책 로딩, 처음 기본값 도메인은 default
        let index = _.findIndex(this.server.policy_json.domains, { domain : this.sel_domain.domain } )
        let policy = Object.assign({}, this.policy_default, this.server.policy_json.domains[index])
        // console.log('policy.mode', policy.mode, this.setting)

        // default 도메인의 기본 설정
        policy.mode = policy.mode == codes.WAF_MODE_ON.TEXT ? 2 : (policy.mode == codes.WAF_MODE_DETECTIONONLY.TEXT ? 1 : 0)

        this.setting = Object.assign({}, default_setting(), this.setting, _.pick(policy, ['mode', 'level']));
        this.setting.status = this.server.policy_json.status; // global option

        this.user = default_user();
        this.using_redir = policy.redirection
        this.is_redir = this.using_redir && this.using_redir.length > 0 ? true : false
        try {
          // _.forEach(policy.custom_rule && policy.custom_rule.split('\n'), r => {
          //   if(r.indexOf('SecRuleUpdateActionById 901000-90000000') > -1 && r.match(/redirect:'(.*?)'/).length) {
          //     this.is_redir = true
          //     return
          //   }
          //   if(this.user.custom_rule.indexOf(r) > -1) { return }
          //   this.user.custom_rule += r
          // })
          this.user.custom_rule = this.base64decode(policy.custom_rule)
          this.user.use_geoip = policy.use_geoip
          this.user.country_code = policy.country_code
          this.user.block_ip = (policy.block_ip || []).join('\n')
          this.user.allow_ip = (policy.allow_ip || []).join('\n')
          this.user.path = (policy.path || []).join('\n')
          this.user.parameter = (policy.parameter || []).join('/')
          this.user.method_control = policy.method_control
          this.user.method_control = this.user.method_control ? this.user.method_control : []
          this.user.method_control.forEach(x => x.ip_list = typeof x.ip_list == typeof '' ? x.ip_list : x.ip_list.join('\n'))
          this.user.use_method = this.sel_domain.use_method

        } catch (e) { console.error("load failed", e); this.user = default_user(); }

        // 방화벽 룰별 상세 설정 -> 자식 뷰에서 처리함
        // _.forEach(this.rule_set.rule, r => {
        //   let block_count = 0
        //   _.forEach(r.rules, s => {
        //     this.setting.mode == codes.WAF_MODE_ON.VALUE ? policy.block.push(s.key) : policy.detect.push(s.key)
        //     s.mode = (this.setting.mode == codes.WAF_MODE_ON.VALUE) // block 일 경우만 true
        //     if(s.mode) { block_count += 1 }
        //   })
        //   r.block = block_count
        //   r.detect = r.rules.length - r.block
        //   console.debug('policy', 'r.block', r.block, 'r.detect', r.detect)
        // })

        // 룰 적용
        this.sel_domain = Object.assign({}, this.sel_domain, policy)

        if(this.server.updated_at == this.server.created_at) { this.quick_setting_status = true; this.is_first = true }

        this.loading = false

        this.ping()

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText, 'miss Connection Error Code : 1'); }
    },
    // 실시간 자원 모니터링, status 로 핑 대체할 수 있음
    res(m) {
      console.log(m)
      // if(m.agent_id != this.server.id) { return;  }
      switch (m.cmd) {
        case "pong":
          this.info = Object.assign({}, this.info, { ms : new Date().getTime() - m.body })
          break;
        case "status":
          this.info = Object.assign({}, this.info, { status : m.body })
          this.info.status.system_cpu_info =  typeof this.info.status.system_cpu_info == typeof '' ? JSON.parse(this.info.status.system_cpu_info) : this.info.status.system_cpu_info
          this.info.status.system_disk_info = typeof this.info.status.system_disk_info == typeof '' ? JSON.parse(this.info.status.system_disk_info) : this.info.status.system_disk_info
          this.info.status.system_memory_info = typeof this.info.status.system_memory_info == typeof '' ? JSON.parse(this.info.status.system_memory_info) : this.info.status.system_memory_info
          break;
        default:
          break;
      }

    },
    async ping(){
      if(this.ping_th) { clearTimeout(this.ping_th); }
      if(!this.server || !this.server.id) { return }

      agent.Cmd("ping", this.server.id)
      agent.Cmd("status", this.server.id)
      this.ping_th = setTimeout(this.ping, 3000)
    },
  },
  watch: { '$route' (to, from) { console.log("from ", from); this.get(to.params.id); },
  },
  created() {
    console.log('modules.detail.vue', 'created');
    return this.get()

  },
  destroyed() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    console.log('modules.detail.vue', 'destroyed');
    signalr.off('webcastle', this.res);
  },
  mounted() {
    console.log('modules.detail.vue', 'mounted');
    // 개선해야 하는 부분, 한번에 요청 방지
    if(this.th) { clearTimeout(this.th); this.th = undefined; console.log("stop sync_log") }
    if(this.ping_th) { clearTimeout(this.ping_th); this.ping_th = undefined; console.log("stop ping & status") }
    signalr.on('webcastle', this.res)
  },
}
